import React from 'react';

const MinimalLayout = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default MinimalLayout;
